'use strict';
 /**
 * @author Maxim Seredkin
 */
import fact from "./module/fact";
import plan from "./module/plan";
import planByYear from "./module/plan_by_year";
import expectedResults from "./module/expected_results";

export default angular.module('investmentProject.project.fund',
    [fact, plan, planByYear, expectedResults])
    .name;